import Util from '../../common/Util';
import {timeline} from './TimelineTmpl';

export default class Timeline {
    constructor( _container, _option ){
        this.nameIs = 'class-Timeline';
        this.container = _container;
        this.option = _option;

        this.nowData = _option.list[0];

        this.pp = null;
        this.pw = null;

        this.timeline = $( timeline() );
        this.progress = this.timeline.find( '.controlbar-progress-bar' );
        $(_container).append( this.timeline );
    }

    addEvents(){
/*         $(this.container).on('click', (e)=>{
            if(!this.pp || !this.pw){
                this.pp = Util.getParentPosition( this.progress );
                this.pw = this.timeline.width();
            }

            let pos = e.pageX - this.pp;
            if (pos > this.pw) pos = this.pw;
            if (pos < 0) pos = 0;
    
            let per = pos/this.pw*100;

            $(this.option.el_sel).trigger({type: 'TIMELINE_CHANGE', time: per/100*this.total, who: this.nameIs});
        }); */
    }

    setNowVideoData(_d){
        this.nowData = _d;
    }

    update(_total, _current){
        if(typeof _total != 'number') _total = 0;
        if(typeof _current != 'number') _current = 0;
        if(_total<_current){
            _current = 0;
            _total = 0;
        }

        let cur = _current - this.nowData.startSeconds;
        let tot = this.nowData.endSeconds - this.nowData.startSeconds;
        
        // console.log( _current, this.nowData.startSeconds, this.nowData.endSeconds );
        // this.total = _total;

        const per = (cur/tot)*100 + '%';
        TweenMax.set(this.progress, {x:per});
    }
    
}